import * as Period from '../../../../constants/Period';
var BEACH_FOOTBBALL_PERIOD_MAP = {};
BEACH_FOOTBBALL_PERIOD_MAP[1800] = Period.NOT_STARTED;
BEACH_FOOTBBALL_PERIOD_MAP[1801] = Period.FIRST;
BEACH_FOOTBBALL_PERIOD_MAP[1802] = Period.FIRST_BREAK;
BEACH_FOOTBBALL_PERIOD_MAP[1803] = Period.SECOND;
BEACH_FOOTBBALL_PERIOD_MAP[1804] = Period.SECOND_BREAK;
BEACH_FOOTBBALL_PERIOD_MAP[1805] = Period.THIRD;
BEACH_FOOTBBALL_PERIOD_MAP[1806] = Period.FULL_TIME;
BEACH_FOOTBBALL_PERIOD_MAP[1807] = Period.OVERTIME;
BEACH_FOOTBBALL_PERIOD_MAP[1808] = Period.OVERTIME_FINISHED;
BEACH_FOOTBBALL_PERIOD_MAP[1809] = Period.PENALTIES;
BEACH_FOOTBBALL_PERIOD_MAP[1810] = Period.FINISHED;
export default BEACH_FOOTBBALL_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/BeachFootball/PeriodMap.js